import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetRealtorRatingListLoading, EGetRealtorRatingActionType } from './types';

export const getRealtorRatingListLoading: () => TGetRealtorRatingListLoading =
  actionGenerator<EGetRealtorRatingActionType.Loading>(EGetRealtorRatingActionType.Loading);
